import styled from "styled-components";
import IUMRSNavBar from "./IUMRSNavbar";
import { ICAMNavroute } from "../../../utils/ICAMnavroute";
import NotificationDropdown from "../../../hooks/notificationsDropdown";
import { Calendar, Clock, MapPin, GraduationCap, CheckCircle, FileText, Menu, BookOpen, Bell} from 'lucide-react';
import { useEffect, useState } from "react";
import IUMRSFooter from "./IUMRSFooter";
import useScreenSize from '../../../hooks/useScreenSize';
import useScrollBarPosition from '../../../hooks/useScrollBarPosition'
import BackToTop from '../../BackToTop'
import groningen_logo from "../../../assets/groningenLogo.png"
import image1 from '../../../assets/speakers-img/Prof Rudolf.png'
import image2 from '../../../assets/speakers-img/Prof. Moniek Tromp.jpg'
import image3 from '../../../assets/speakers-img/Prof. Guiseppe Portale.jpg'

import { dayOne, dayTwo, sections} from "../../../utils/winterschoolschedule";



const IUMRSWorkshop = () => {
  const [activeSection, setActiveSection] = useState('overview');
  const [showMobileNav, setisMobileNav] = useState(false);
  const {width} = useScreenSize();
  const scrollPosition = useScrollBarPosition();
  


  useEffect(() => {
    const handleScroll = () => {
      const sectionElements = sections.map(s => ({
        id: s.id,
        element: document.getElementById(s.id)
      }));

      const scrollPosition = window.scrollY + 150;

      for (let i = sectionElements.length - 1; i >= 0; i--) {
        const section = sectionElements[i];
        if (section.element && section.element.offsetTop <= scrollPosition) {
          setActiveSection(section.id);
          break;
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

 useEffect(() => {
  const buttons = document.getElementsByClassName("side-bar-menu");
  if (width < 850) {
    if (buttons.length > 0) {
      buttons[0].style.display = "block";
    }
  }
  else {
    if (buttons.length > 0) {
      buttons[0].style.display = "none";
    }
    setisMobileNav(false);
  }
}, [width]);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 100;
      const elementPosition = element.offsetTop - offset;
      window.scrollTo({
        top: elementPosition,
        behavior: 'smooth'
      });
    }
  };

  const toggleMobileNav = () => {
  setisMobileNav(!showMobileNav);
  };

    return (
        <Container>
            <IUMRSNavBar navroute={ICAMNavroute} />
            <NotificationDropdown />
            
            <PageContainer>
                <Header>
                    <HeaderContent>
                      <HeaderLeft>
                        <Title>SUSTAINABLE AND RENEWABLE ENERGY</Title>
                        <Subtitle>Winter School 2025</Subtitle>
                        <HeaderInfo>
                            <InfoItem>
                              <Calendar size={20} />
                              <span>December 7-8, 2025</span>
                            </InfoItem>
                            <InfoItem>
                              <Clock size={20} />
                              <span>2 Days</span>
                            </InfoItem>
                            <InfoItem>
                              <MapPin size={20} />
                              <span>Virtual & On-site</span>
                            </InfoItem>
                        </HeaderInfo>
                      </HeaderLeft>
                      
                      <HeaderRight>
                        <CollaborationText>In Collaboration With</CollaborationText>
                        <PartnerLogos>
                          <PartnerTextLogo>
                            <PartnerName>ARUA</PartnerName>
                            <PartnerSubtext>GUILD CORE RE</PartnerSubtext>
                          </PartnerTextLogo>
                          <UniversityLogo src={groningen_logo} alt="University of Groningen" />
                        </PartnerLogos>                      
                      </HeaderRight>
                    </HeaderContent>
                </Header>

                <MainContent>
                    <Navigation>
                      <button className="side-bar-menu" onClick={toggleMobileNav}>
                        <Menu size={16} />
                      </button>
                      <NavCard className="nav-card" $showMobile={showMobileNav}>
                        <NavTitle>Navigation</NavTitle>
                        <NavList>
                          {sections.map((section) => {
                            const Icon = section.icon;
                            return (
                              <li key={section.id}>
                                <NavButton
                                  onClick={() => {
                                    scrollToSection(section.id);
                                    if (width < 850) {
                                      setisMobileNav(false);
                                    }
                                  }}
                                  $active={activeSection === section.id}
                                >
                                  <Icon size={16} />
                                  <span>{section.label}</span>
                                </NavButton>
                              </li>
                            );
                          })}
                        </NavList>
                      </NavCard>
                    </Navigation>

                    <ContentArea>
                      <Section id="overview">
                        <SectionHeader>
                          <BookOpen size={32} color="#0c4e80ff" />
                          General Information
                        </SectionHeader>
                        <SectionContent>
                          <GeneralInfoText>
                            The Winter School on Sustainable and Renewable Energy is organized in collaboration with <strong>ARUA-GUILD CORE - RE</strong> and the <strong>University of Groningen</strong>, one of Europe's leading research institutions in energy materials and sustainability science. This partnership brings together cutting-edge research expertise and innovative pedagogical approaches to deliver a world-class learning experience.
                          </GeneralInfoText>
                          
                          <GeneralInfoText>
                            Through this collaboration, participants will benefit from direct access to internationally recognized researchers, state-of-the-art methodologies, and real-world applications of sustainable energy technologies. The program emphasizes hands-on learning, interdisciplinary dialogue, and the development of practical skills essential for advancing renewable energy solutions in diverse contexts.
                          </GeneralInfoText>

                          <CollaborationHighlight>
                            <HighlightIcon>
                              <GraduationCap size={24} color="#CA9D3B" />
                            </HighlightIcon>
                            <HighlightText>
                              This winter school represents a strategic partnership aimed at fostering knowledge exchange and building research capacity in sustainable energy materials across Africa and Europe.
                            </HighlightText>
                          </CollaborationHighlight>

                          <SpeakersSection>
                            <SpeakersTitle>Guest Speakers from University of Groningen</SpeakersTitle>
                            <SpeakersSubtitle>
                              We are honored to host distinguished researchers who will share their expertise and insights
                            </SpeakersSubtitle>
                            
                            <SpeakersGrid>
                              <SpeakerCard>
                                <SpeakerImageWrapper>
                                  <SpeakerImage src={image1} alt="Prof. Petra Rudolf" />
                                  <SpeakerOverlay>
                                    <SpeakerRole>Keynote Speaker</SpeakerRole>
                                  </SpeakerOverlay>
                                </SpeakerImageWrapper>
                                <SpeakerInfo>
                                  <SpeakerName>Prof. Petra Rudolf</SpeakerName>
                                  <SpeakerTitle>Professor Experimental Solid State Physics and Dean of Graduate Studies</SpeakerTitle>
                                  <SpeakerBio>
                                    Experimental Solid State Physics, Surface Science, Electron spectroscopy, organic thin films, molecular switches and motors, organic-inorganic hybrids, 2D solids                                  </SpeakerBio>
                                </SpeakerInfo>
                              </SpeakerCard>

                              <SpeakerCard>
                                <SpeakerImageWrapper>
                                  <SpeakerImage src={image2} alt="Prof. Moniek Tromp" />
                                  <SpeakerOverlay>
                                    <SpeakerRole>Invited Speaker</SpeakerRole>
                                  </SpeakerOverlay>
                                </SpeakerImageWrapper>
                                <SpeakerInfo>
                                  <SpeakerName>Prof. Moniek Tromp</SpeakerName>
                                  <SpeakerTitle>Director Zernike Insitute for Advanced Materials</SpeakerTitle>
                                  <SpeakerBio>
                                    Specializes in perovskite solar cells and hybrid materials with extensive experience in translating laboratory innovations to practical applications.
                                  </SpeakerBio>
                                </SpeakerInfo>
                              </SpeakerCard>

                              <SpeakerCard>
                                <SpeakerImageWrapper>
                                  <SpeakerImage src={image3} alt="Prof. Giuseppe Portale" />
                                  <SpeakerOverlay>
                                    <SpeakerRole>Invited Speaker</SpeakerRole>
                                  </SpeakerOverlay>
                                </SpeakerImageWrapper>
                                <SpeakerInfo>
                                  <SpeakerName>Prof. Giuseppe Portale</SpeakerName>
                                  <SpeakerTitle>Associate professor and chair of Polymer Physics research group</SpeakerTitle>
                                  <SpeakerBio>
                                    Expert in synthesis and structure-property study of polymeric and soft materials for energy applications
                                  </SpeakerBio>
                                </SpeakerInfo>
                              </SpeakerCard>
                            </SpeakersGrid>
                          </SpeakersSection>
                        </SectionContent>
                      </Section>
                      <Section id="notice">
                          <SectionHeader>
                          <Bell size={32} color="#0c4e80ff" />
                          Important Notice
                          </SectionHeader>
                          <SectionContent>
                          <InfoBox $color="#0c4e80ff">
                              <InfoBoxTitle>Duration & Schedule</InfoBoxTitle>
                              <p className="info-box-content">The winter school will run for 2 consecutive days from December 7-8, 2025 as part of the pre-conference workshops organized for the ICAM-IUMRS 2025 conference. It begins with a keynote lecture from Prof. Petra Rudolf at 9:00 AM on Day one.</p>
                          </InfoBox>
                          <InfoBox $color="#0c4e80ff">
                              <InfoBoxTitle>Location</InfoBoxTitle>
                              <p className="info-box-content"> Join us in person at the Cedi Conference Center on the University of Ghana campus. Remote participation will be available via a shared online video conferencing link.</p>
                          </InfoBox>
                          <InfoBox $color="#0c4e80ff">
                              <InfoBoxTitle>Registration Fee</InfoBoxTitle>
                              <p className="info-box-content">No separate registration fee is required for participation. All Participants attending the IUMRS-ICAM 2025 conference are welcomed to join</p>
                          </InfoBox>
                          </SectionContent>
                      </Section>

                      <Section id="requirements">
                          <SectionHeader>
                          <CheckCircle size={32} color="#0c4e80ff" />
                          Requirements
                          </SectionHeader>
                          <SectionContent>
                          <InfoBoxTitle>Prerequisites</InfoBoxTitle>
                          <List>
                              <ListItem>
                              <Bullet>•</Bullet>
                              <span>Bachelor's degree in a related field or equivalent professional experience</span>
                              </ListItem>
                              <ListItem>
                              <Bullet>•</Bullet>
                              <span>Basic understanding of research methodologies</span>
                              </ListItem>
                              <ListItem>
                              <Bullet>•</Bullet>
                              <span>Sufficient proficiency in the English language</span>
                              </ListItem>
                          </List>
                          <InfoBoxTitle style={{ marginTop: '1.5rem' }}>What to Bring</InfoBoxTitle>
                          <List>
                              <ListItem>
                              <Bullet $color="#4f46e5">•</Bullet>
                              <span>Notebook and writing materials</span>
                              </ListItem>
                              <ListItem>
                              <Bullet $color="#4f46e5">•</Bullet>
                              <span>Laptop for taking detailed notes and accessing digital materials (optional)</span>
                              </ListItem>
                          </List>
                          </SectionContent>
                      </Section>

                      <Section id="content">
                          <SectionHeader>
                          <FileText size={32} color="#0c4e80ff" />
                          Course Content
                          </SectionHeader>
                          <SectionContent>
                          <DayCard $bg="#fcfcfcff">
                              <DayTitle $color="#CA9D3B">Day 1: Foundations of Sustainable Energy Materials</DayTitle>
                              <List>
                              <ListItem>•<span style={{fontWeight: 600}}>Plenary Talk:</span> Frontiers in Nanomaterials for Energy</ListItem>
                              <ListItem>•<span style={{fontWeight: 600}}>Lecture Session:</span> Perovskite and Hybrid Solar Materials</ListItem>
                              <ListItem>•<span style={{fontWeight: 600}}>Hands-on Workshop:</span> Solar Cell Fabrication & Testing</ListItem>
                              <ListItem>•<span style={{fontWeight: 600}}>Lecture Session:</span> Battery Materials & Electrochemical Storage</ListItem>
                              </List>
                          </DayCard>
                          <DayCard $bg="#fcfcfcff">
                              <DayTitle $color="#CA9D3B">Day 2: Implementation, Impact, and Collaboration*</DayTitle>
                              <List>
                              <ListItem>•<span style={{fontWeight: 600}}>Lecture Session:</span> Waste-to-Energy & Circular Materials</ListItem>
                              <ListItem>•<span style={{fontWeight: 600}}>Lecture Session:</span> Life Cycle Assessment & Policy Mapping</ListItem>
                              <ListItem>•<span style={{fontWeight: 600}}>Hands-on Workshop:</span> LCA Simulation & Stakeholder Mapping</ListItem>
                              <ListItem>•<span style={{fontWeight: 600}}>Panel Discussion:</span> Innovation Hubs & Industry-Academia Partnerships</ListItem>

                              </List>
                          </DayCard>
                          </SectionContent>
                      </Section>

                      <Section id="outcomes">
                          <SectionHeader>
                          <GraduationCap size={32} color="#0c4e80ff" />
                          Learning Outcomes
                          </SectionHeader>
                          <SectionContent>
                          <p style={{ fontSize: '1.125rem', marginBottom: '1rem' }}>Upon completion of this winter school, participants will be able to:</p>
                          <OutcomeCard>
                              <IconWrapper $bg="#dbeafe">
                              <CheckCircle size={20} color="#2563eb" />
                              </IconWrapper>
                              <OutcomeContent>
                              <OutcomeTitle>Integration of Advanced Materials in Sustainable Energy Systems</OutcomeTitle>
                              <OutcomeText>Gain foundational knowledge of perovskite and hybrid solar materials, and electrochemical storage systems and how these materials contribute to efficient and sustainable energy technologies</OutcomeText>
                              </OutcomeContent>
                          </OutcomeCard>
                          <OutcomeCard>
                              <IconWrapper $bg="#e0e7ff">
                              <CheckCircle size={20} color="#2563eb" />
                              </IconWrapper>
                              <OutcomeContent>
                              <OutcomeTitle>Application of Material Characterization and Fabrication Techniques</OutcomeTitle>
                              <OutcomeText>develop practical skills in solar cell fabrication, testing, and prototyping of local energy solutions.</OutcomeText>
                              </OutcomeContent>
                          </OutcomeCard>
                          <OutcomeCard>
                              <IconWrapper $bg="#dbeafe">
                              <CheckCircle size={20} color="#2563eb" />
                              </IconWrapper>
                              <OutcomeContent>
                              <OutcomeTitle>Evaluation of Sustainability and Circularity in Material Use</OutcomeTitle>
                              <OutcomeText>Learn to assess and apply life cycle, waste-to-energy, and circular material principles to reduce environmental impact and promote resource-efficient production systems.</OutcomeText>
                              </OutcomeContent>
                          </OutcomeCard>
                          <OutcomeCard>
                              <IconWrapper $bg="#dbeafe">
                              <CheckCircle size={20} color="#2563eb" />
                              </IconWrapper>
                              <OutcomeContent>
                              <OutcomeTitle>Interdisciplinary Insight into Energy, Health, and Built Environments</OutcomeTitle>
                              <OutcomeText>Explore the nexus between materials for energy and health applications, as well as sustainable building materials and deployment strategies.</OutcomeText>
                              </OutcomeContent>
                          </OutcomeCard>
                          <OutcomeCard>
                              <IconWrapper $bg="#e0e7ff">
                              <CheckCircle size={20} color="#2563eb" />
                              </IconWrapper>
                              <OutcomeContent>
                              <OutcomeTitle>Certificate: 14 hours (~0.5 ECTS) workload.</OutcomeTitle>
                              <OutcomeText>The course content covers theoretical and practical components, equivalent to the expected effort for a short university-level module.</OutcomeText>
                              </OutcomeContent>
                          </OutcomeCard>
                          </SectionContent>
                      </Section>

                      <Section id="schedule">
                          <SectionHeader>
                          <FileText size={32} color="#0c4e80ff" />
                          Schedule of Events
                          </SectionHeader>
                          <SectionContent>
                            <TableContainer>
                              <label >PROGRAM SCHEDULE FOR DAY 1</label>
                              <StyledTable>
                                <TableHead>
                                  <TableRow>
                                    <TableHeader>Time</TableHeader>
                                    <TableHeader>Session</TableHeader>
                                    <TableHeader>Facilitator(s)</TableHeader>
                                    <TableHeader>Description</TableHeader>
                                  </TableRow>
                                </TableHead>
                                <tbody>
                                  {dayOne.map((item, index) => (
                                    <TableRow key={index}>
                                      <TableCell>{item.time}</TableCell>
                                      <TableCell>
                                        <SessionTitle>{item.session}</SessionTitle>
                                      </TableCell>
                                      <TableCell>{item.facilitators}</TableCell>
                                      <TableCell>
                                        <Description>{item.description}</Description>
                                      </TableCell>
                                    </TableRow>
                                  ))}
                                </tbody>
                              </StyledTable>
                            </TableContainer>

                            <p style={{fontStyle: "italic"}}>**Please note that the schedule for Day 2 is currently being finalized. The updated program will be published on this page once available.**</p>
                          </SectionContent>
                      </Section>

                      <ApplicationSection id="application">
                          <SectionHeader style={{ color: 'white' }}>
                          <FileText size={32} />
                          Application Procedure
                          </SectionHeader>
                          <SectionContent>
                          <ApplicationBox>
                              <ApplicationTitle>How to Apply</ApplicationTitle>
                              <OrderedList>
                              <OrderedListItem>
                                  <StepNumber>1.</StepNumber>
                              <span>Fill in the online registration form on our website </span>
                              </OrderedListItem>
                              <OrderedListItem>
                                  <StepNumber>2.</StepNumber>
                                  <span>Select the option "Register for pre-conference workshop"</span>
                              </OrderedListItem>
                              <OrderedListItem>
                                  <StepNumber>3.</StepNumber>
                                  <span>Tick the "Winter School on Sustainable and Renewable energy" option to register</span>
                              </OrderedListItem>
                              <OrderedListItem>
                                  <StepNumber>4.</StepNumber>
                                  <span>Proceed to payment after filling the registration form or by using the payment initializer <a style={{color:"#CA9D3B", textDecoration: "none"}} href="/event/payment-initializer">here</a></span>
                              </OrderedListItem>
                              </OrderedList>
                          </ApplicationBox>
                          <ButtonContainer>
                              <ApplyButton onClick={ () => window.location.href = '/iumrs-icam25/registration'}>Apply Now</ApplyButton>
                          </ButtonContainer>
                          </SectionContent>
                      </ApplicationSection>
                    </ContentArea>
                </MainContent>

                <IUMRSFooter />
                </PageContainer>
            { width < 850 ? (scrollPosition > 50) && <BackToTop /> : (scrollPosition > 95) && <BackToTop />}
        </Container>
    )
}

const Container = styled.div`

`


const PageContainer = styled.div`
  min-height: 100vh;
  background: linear-gradient(to bottom right, #eff6ff, #ffffff, #eef2ff);
  font-family: "Noto Serif", serif;
  font-weight: 400;
  font-size: 1rem;
  overflow-x: clip;
  width: 100%;

  .info-box-content{
    text-align: justify;
    line-height: 1.8rem;
    font-size: 1rem;
    word-spacing: 3px;
    font-weight: 300;

    @media (max-width: 850px) {
    font-size: 0.9rem;
    line-height: 1.3rem;
    }
  }

  @media (max-width: 850px) {
    font-size: 0.9rem;
  }
`;

const Header = styled.header`
  background: linear-gradient(to right, #082D4A, #0c4e80ff, #8ba5b8);
  color: white;
  padding: 4rem 1.5rem;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
  width: 100%;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;

  /* Subtle pattern overlay */
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: 
      radial-gradient(circle at 20% 50%, rgba(255,255,255,0.05) 0%, transparent 50%),
      radial-gradient(circle at 80% 80%, rgba(255,255,255,0.03) 0%, transparent 50%);
    pointer-events: none;
  }

  @media only screen and (max-width: 768px) {
    padding: 2rem 1rem;
  }
`;

const HeaderContent = styled.div`
  max-width: 72rem;
  margin: 0 auto;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 3rem;
  position: relative;
  z-index: 1;

  @media (max-width: 850px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 2rem;
  }
`;

const HeaderLeft = styled.div`
  flex: 1;
  max-width: 65%;

  @media (max-width: 850px) {
    max-width: 100%;
    margin-top: 1.5rem;
  }
`;

const HeaderRight = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 1rem;
  flex-shrink: 0;
  text-align: right;

  @media (max-width: 850px) {
    width: 100%;
    align-items: center;
    text-align: center;
  }
`;


const CollaborationText = styled.div`
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.9);
  font-weight: 300;
  margin-bottom: 0.5rem;
  letter-spacing: 0.5px;

  @media (max-width: 850px) {
    font-size: 0.85rem;
  }
`;

const PartnerLogos = styled.div`
  display: flex;
  align-items: center;
  gap: 1.5rem;
  flex-wrap: wrap;
  justify-content: flex-end;

  @media (max-width: 850px) {
    justify-content: center;
    gap: 1rem;
  }
`;

const PartnerTextLogo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.95);
  padding: 1rem 1.5rem;
  border-radius: 0.5rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  min-width: 180px;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
  }

  @media (max-width: 850px) {
    min-width: 150px;
    padding: 0.8rem 1.2rem;
  }

  @media (max-width: 480px) {
    min-width: 130px;
    padding: 0.7rem 1rem;
  }
`;

const PartnerName = styled.span`
  font-size: 1.4rem;
  font-weight: 700;
  color: #0c4e80ff;
  letter-spacing: 1.5px;
  text-align: center;
  line-height: 1.3;

  @media (max-width: 850px) {
    font-size: 0.95rem;
    letter-spacing: 1px;
  }

  @media (max-width: 480px) {
    font-size: 0.85rem;
  }
`;

const PartnerSubtext = styled.span`
  font-size: 0.9rem;
  font-weight: 500;
  color: #CA9D3B;
  letter-spacing: 1px;
  margin-top: 0.3rem;
  text-transform: uppercase;

  @media (max-width: 850px) {
    font-size: 0.65rem;
  }

  @media (max-width: 480px) {
    font-size: 0.6rem;
  }
`;

const UniversityLogo = styled.img`
  height: 120px;
  width: auto;
  object-fit: contain;
  filter: brightness(1.1);
  transition: transform 0.3s ease;

  &:hover {
    transform: scale(1.05);
  }
  
  @media (max-width: 850px) {
    height: 90px;
  }

  @media (max-width: 480px) {
    height: 70px;
  }
`;


const Title = styled.h1`
  font-size: 3rem;
  font-weight: bold;
  margin-bottom: 1rem;
  word-break: break-word;

  @media (max-width: 850px) {
    font-size: 1.85rem;
  }
`;

const Subtitle = styled.p`
  font-size: 1.25rem;
  color: #bfdbfe;
  word-break: break-word;

  @media (max-width: 850px) {
    font-size: 1rem;
  }
`;

const HeaderInfo = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem;
  margin-top: 1.5rem;
  font-size: 0.875rem;

  @media (max-width: 850px) {
    gap: 1rem;
    font-size: 0.8rem;
  }
`;

const InfoItem = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

const MainContent = styled.div`
  max-width: 72rem;
  margin: 0 auto;
  padding: 3rem 1.5rem;
  display: flex;
  align-items: flex-start;
  gap: 2rem;
  width: 100%;
  box-sizing: border-box;
  overflow: visible;

  @media only screen and (max-width: 850px){
    display: block;
    padding: 2rem 1rem;
    gap: 0;
  }
`;

const Navigation = styled.div`
  width: 16rem;
  flex-shrink: 0;
  position: sticky;
  top: 5rem;
  height: fit-content;
  z-index: 2;
  align-self: flex-start;

  .side-bar-menu{
    display: none;
    background: #0c4e80ff;
    color: white;
    border: none;
    padding: 0.75rem 1rem;
    border-radius: 0.5rem;
    cursor: pointer;
    margin-bottom: 1rem;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    align-items: center;
    justify-content: center;
    width: fit-content;
    
    &:hover {
      background: #082D4A;
    }
  }

  @media only screen and (max-width: 850px){
    width: 100%;
    position: relative;
    top: 0;
    margin-bottom: 1.5rem;
    align-self: auto;
  }
`;

const NavCard = styled.div`
  background: white;
  border-radius: 0.75rem;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
  padding: 0.5rem 1.5rem;
  box-sizing: border-box;

  @media only screen and (max-width: 850px){
    width: 100%;
    max-width: 100%;
    display: ${props => props.$showMobile ? 'block' : 'none'};
    position: absolute;
    z-index: 10;
    max-height: 80vh;
    overflow-y: auto;
    left: 0;
    right: 0;
    margin: 0 1rem;
    width: calc(100% - 2rem);
  }
`;

const NavTitle = styled.h2`
  font-size: 1.125rem;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 1rem;
`;

const NavList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

const NavButton = styled.button`
  width: 100%;
  text-align: left;
  padding: 0.75rem 1rem;
  border-radius: 0.5rem;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-size: 0.875rem;
  font-weight: 500;
  transition: all 0.2s;
  background: ${props => props.$active ? '#CA9D3B' : 'transparent'};
  color: ${props => props.$active ? 'white' : '#374151'};
  box-shadow: ${props => props.$active ? '0 4px 6px -1px rgba(0, 0, 0, 0.1)' : 'none'};

  &:hover {
    background: ${props => props.$active ? '#CA9D3B' : '#eff6ff'};
  }
`;

const ContentArea = styled.main`
  flex: 1;
  min-width: 0; /* Important for flex items to shrink properly */
  width: 100%;
  box-sizing: border-box;

  @media only screen and (max-width: 850px){
    width: 100%;
  }
`;

const Section = styled.section`
  margin-bottom: 4rem;
  background: white;
  border-radius: 0.75rem;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
  padding: 2rem;
  width: 100%;
  box-sizing: border-box;
  overflow-x: hidden; /* Prevent content from overflowing */

  @media (max-width: 850px) {
    padding: 1.25rem;
    margin-bottom: 2rem;
    border-radius: 0.5rem;
  }
`;

const SectionHeader = styled.h2`
  font-size: 1.875rem;
  font-weight: bold;
  color: #1f2937;
  margin-bottom: 1.5rem;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;
  word-break: break-word;

  @media (max-width: 850px) {
    font-size: 1.35rem;
    
    svg {
      width: 24px;
      height: 24px;
      flex-shrink: 0;
    }
  }
`;

const SectionContent = styled.div`
  color: #374151;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
  box-sizing: border-box;
  overflow-x: hidden;

  label { 
    display: flex; 
    font-size: 1rem;
    justify-content: center; 
    margin-bottom: 0.8rem; 
    text-decoration: underline;
    word-break: break-word;
  }
`;

const GeneralInfoText = styled.p`
  font-size: 1rem;
  line-height: 1.8;
  color: #374151;
  margin-bottom: 1rem;
  text-align: justify;
  
  strong {
    color: #0c4e80ff;
    font-weight: 600;
  }

  @media (max-width: 850px) {
    font-size: 0.95rem;
    text-align: left;
  }
`;

const CollaborationHighlight = styled.div`
  background: linear-gradient(135deg, #0c4e80ff 0%, #082D4A 100%);
  border-radius: 0.75rem;
  padding: 1.5rem;
  display: flex;
  gap: 1rem;
  align-items: start;
  margin: 1.5rem 0;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);

  @media (max-width: 850px) {
    flex-direction: column;
    padding: 1.25rem;
  }
`;

const HighlightIcon = styled.div`
  background: white;
  border-radius: 50%;
  padding: 0.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

const HighlightText = styled.p`
  color: white;
  font-size: 1.05rem;
  line-height: 1.7;
  margin: 0;
  font-style: italic;

  @media (max-width: 850px) {
    font-size: 0.95rem;
  }
`;

const SpeakersSection = styled.div`
  margin-top: 3rem;
  padding-top: 2rem;
  border-top: 2px solid #e5e7eb;
`;

const SpeakersTitle = styled.h3`
  font-size: 1.75rem;
  font-weight: bold;
  color: #0c4e80ff;
  margin-bottom: 0.5rem;
  text-align: center;

  @media (max-width: 850px) {
    font-size: 1.4rem;
  }
`;

const SpeakersSubtitle = styled.p`
  font-size: 1rem;
  color: #6b7280;
  text-align: center;
  margin-bottom: 2.5rem;
  font-style: italic;

  @media (max-width: 850px) {
    font-size: 0.9rem;
    margin-bottom: 2rem;
  }
`;

const SpeakersGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 2rem;
  margin-top: 2rem;

  @media (max-width: 850px) {
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 1.5rem;
  }
`;

const SpeakerCard = styled.div`
  background: #fcfcfcff;
  border-radius: 0.75rem;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 15px rgba(0, 0, 0, 0.15);
  }
`;

const SpeakerImageWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 300px;
  overflow: hidden;
  background: linear-gradient(135deg, #0c4e80ff 0%, #082D4A 100%);

  @media (max-width: 850px) {
    height: 250px;
  }
`;

const SpeakerImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  transition: transform 0.3s ease;

  ${SpeakerCard}:hover & {
    transform: scale(1.05);
  }
`;

const SpeakerOverlay = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(to top, rgba(12, 78, 128, 0.95), transparent);
  padding: 1rem;
  transform: translateY(100%);
  transition: transform 0.3s ease;

  ${SpeakerCard}:hover & {
    transform: translateY(0);
  }
`;

const SpeakerRole = styled.span`
  color: #CA9D3B;
  font-weight: 600;
  font-size: 0.9rem;
  text-transform: uppercase;
  letter-spacing: 1px;
`;

const SpeakerInfo = styled.div`
  padding: 1.5rem;
`;

const SpeakerName = styled.h4`
  font-size: 1.25rem;
  font-weight: bold;
  color: #0c4e80ff;
  margin-bottom: 0.25rem;

  @media (max-width: 850px) {
    font-size: 1.1rem;
  }
`;

const SpeakerTitle = styled.p`
  font-size: 0.9rem;
  color: #CA9D3B;
  font-weight: 600;
  margin-bottom: 0.75rem;
`;

const SpeakerBio = styled.p`
  font-size: 0.9rem;
  color: #4b5563;
  line-height: 1.6;
  font-weight: 300;

  @media (max-width: 850px) {
    font-size: 0.85rem;
  }
`;

const InfoBox = styled.div`
  border-left: 4px solid ${props => props.$color || '#2563eb'};
  padding-left: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  box-sizing: border-box;
  width: 100%;
  overflow-wrap: break-word;
  word-break: break-word;
`;

const InfoBoxTitle = styled.h3`
  font-weight: 600;
  font-size: 1.125rem;
  margin-bottom: 0.5rem;
  word-break: break-word;

  @media (max-width: 850px) {
    font-size: 1rem;
  }
`;

const List = styled.ul`
  list-style: none;
  padding: 0;
  margin-left: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

const ListItem = styled.li`
  display: flex;
  align-items: start;
  gap: 0.5rem;
  font-weight: 200;
`;

const Bullet = styled.span`
  color: ${props => props.$color || '#2563eb'};
  margin-top: 0.25rem;
`;

const DayCard = styled.div`
  background: ${props => props.$bg || '#eff6ff'};
  border-radius: 0.5rem;
  padding: 1.5rem;
`;

const DayTitle = styled.h3`
  font-weight: bold;
  font-size: 1.25rem;
  color: ${props => props.$color || '#1e40af'};
  margin-bottom: 0.75rem;
`;

const OutcomeCard = styled.div`
  display: flex;
  gap: 1rem;
  align-items: start;
`;

const IconWrapper = styled.div`
  background: ${props => props.$bg || '#dbeafe'};
  border-radius: 9999px;
  padding: 0.5rem;
  margin-top: 0.25rem;
`;

const OutcomeContent = styled.div`
  flex: 1;
`;

const OutcomeTitle = styled.h4`
  font-weight: 600;
  margin-bottom: 0.25rem;
`;

const OutcomeText = styled.p`
  text-align: justify;
  color: #4b5563;
  font-weight: 300;
`;

const ApplicationSection = styled(Section)`
  background-color: #0c4e80ff;
  color: white;
  overflow-x: hidden;
`;

const ApplicationBox = styled.div`
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border-radius: 0.5rem;
  padding: 1.5rem;
  color: white;
  box-sizing: border-box;
  width: 100%;
  overflow-wrap: break-word;

  @media (max-width: 850px) {
    padding: 1rem;
  }
`;

const ApplicationTitle = styled.h3`
  font-weight: 600;
  font-size: 1.25rem;
  margin-bottom: 0.75rem;
`;

const OrderedList = styled.ol`
  list-style: none;
  padding: 0;
  margin-left: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

const OrderedListItem = styled.li`
  display: flex;
  gap: 0.75rem;
`;

const StepNumber = styled.span`
  font-weight: bold;
`;

const ButtonContainer = styled.div`
  text-align: center;
  padding-top: 1rem;
`;

const ApplyButton = styled.button`
  background: white;
  color: #2563eb;
  padding: 1rem 2rem;
  border-radius: 0.5rem;
  font-weight: 600;
  font-size: 1.125rem;
  border: none;
  cursor: pointer;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
  transition: background 0.2s;

  &:hover {
    background: #eff6ff;
  }
`;



const TableContainer = styled.div`
  width: 100%;
  overflow-x: auto;
  padding: 1rem;
  border-radius: 16px;
  -webkit-overflow-scrolling: touch;
  box-sizing: border-box;

  @media (max-width: 850px) {
    padding: 0.5rem 0;
    margin: 0 -0rem;
    width: calc(100% + 2.5rem);
    border-radius: 0;
  }
`;

const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  min-width: 700px;
  background: white;
  border-radius: 12px;
  overflow: hidden;

  @media (max-width: 768px) {
    font-size: 0.85rem;
  }
`;

const TableHead = styled.thead`
  background-color: #004b87;
  color: white;
`;

const TableRow = styled.tr`
  border-bottom: 1px solid #e5e7eb;
  &:last-child {
    border-bottom: none;
  }
`;

const TableHeader = styled.th`
  text-align: left;
  padding: 1rem;
  font-weight: 600;
  font-size: 0.95rem;
  white-space: nowrap;
`;

const TableCell = styled.td`
  padding: 1rem;
  vertical-align: top;
  font-size: 0.9rem;
  color: #374151;

  &:first-child {
    font-weight: 600;
    color: #111827;
  }
`;

const SessionTitle = styled.span`
  font-weight: 600;
  color: #004b87;
`;

const Description = styled.p`
  margin: 0.3rem 0 0 0;
  color: #4b5563;
`;
export default IUMRSWorkshop;